import * as CL from '@design-system/component-library';
import {
  changeRequestInProgressMsg,
  eppDeviceDisclaimerBodyMsg,
  returnToSubscriptionPageMsg,
  t,
} from '../../common/i18n/index.js';

import './EppDestroyedOrMissingDevicePending.scss';

interface EppDestroyedOrMissingDevicePendingProps {
  onClose: () => void;
}

export const EppDevicePendingActionsDisclaimer = ({ onClose }: EppDestroyedOrMissingDevicePendingProps) => (
  <div className="of-epp-maintenance-disclaimer">
    <CL.Disclaimer title={t.V09R(changeRequestInProgressMsg)} text={t.O7DE(eppDeviceDisclaimerBodyMsg)} visible />
    <CL.Button color="link" className="of-epp-maintenance-disclaimer--link" onClick={onClose}>
      {t.D30R(returnToSubscriptionPageMsg)}
    </CL.Button>
  </div>
);
